import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';  // MobX 에서 사용하는 Provider
import { RootStore } from 'stores'; // *** 루트 스토어 생성
import { AntdConfig, QueryConfig } from 'config'
import RootRouter from 'routers';

const Root = () => {
  return (
    <AntdConfig>
      <QueryConfig>
        <Provider {...RootStore} >  
          <BrowserRouter basename="/">
            <RootRouter />
          </BrowserRouter>
        </Provider>
      </QueryConfig>
    </AntdConfig>
  );
}

export default Root;
